import React, { useState } from 'react'
import { Box } from '@mui/material'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SelectedStarLogo from 'src/assets/Buy_Policy_Images/starSelected.svg'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'

const RoadSafetyTile = ({
  logo,
  text,
  setRating,
  ruleSelected,
  setRuleSelected,
  ruleId,
  rating,
}) => {
  const classes = useStyles()
  const [likeClicked, setLikeClicked] = useState(false)

  const handleRuleLike = () => {
    if (!likeClicked) {
      setRuleSelected(true)
      setRating((prevState) => prevState + 1)
      setLikeClicked(true)
    }
  }

  const handleRuleUnLike = () => {
    setRuleSelected(false)
    setRating((prevState) => prevState - 1)
    setLikeClicked(false)
  }

  return (
    <Box>
      <Box className={classes.ruleTileMain}>
        {ruleSelected || ruleId <= rating ? (
          <img
            className={classes.selectedStar}
            src={SelectedStarLogo}
            height={'33px'}
            width={'34.74px'}
            alt='selected-star'
          />
        ) : null}

        <Box className={classes.highlightedRuleTile}>
          <Box className={classes.ruleLogo}>
            <img src={logo} alt='rule-logo' />
          </Box>
          <Box className={classes.ruleText}>{text}</Box>
          <Box className={classes.ruleLikeConatiner}>
            <Box className={classes.iUnderstandText}>I understand</Box>
            <Box className={classes.ruleLikeSection}>
              <Box>
                <Button
                  className={`${classes.likeBtn} ${
                    likeClicked ? classes.selectedBtn : ''
                  }`}
                  variant='contained'
                  onClick={handleRuleLike}
                  disabled={likeClicked}
                  id='thumbUpButton'
                >
                  <ThumbUpIcon
                    className={`${classes.likeIcon} ${
                      likeClicked ? classes.selectedIcon : ''
                    }`}
                  />
                </Button>
              </Box>
              <Box>
                <Button
                  className={classes.unlikeBtn}
                  variant='contained'
                  onClick={handleRuleUnLike}
                  disabled={!ruleSelected}
                  id='thumbDownButton'
                >
                  <ThumbDownIcon className={classes.unlikeIcon} />
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RoadSafetyTile

const useStyles = makeStyles({
  ruleTileMain: {
    position: 'relative',
  },

  ruleTile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    borderRadius: '20px',
    boxShadow: '0px -6px 15px 0px #A6C9D233',
    background: '#FFFFFF',
    gap: 30,
    padding: 20,
  },
  highlightedRuleTile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    borderRadius: '20px',
    boxShadow: '0px 10px 15px 0px #A6C9D233',
    background: '#FFFFFF',
    gap: 30,
    padding: 20,
  },
  ruleLogo: {},
  ruleText: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20.83px',
    letterSpacing: '0em',
    color: '#000000',
  },
  ruleLikeSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
  },
  ruleTileContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  ruleLikeConatiner: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
  },
  likeIcon: {
    color: '#13C5F5',
  },
  unlikeIcon: {
    color: '#C65583',
  },
  likeBtn: {
    width: '56px',
    height: '52px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #4DC3E3 -76.92%, rgba(255, 255, 255, 0) 68.27%), linear-gradient(0deg, #BDE5F0, #BDE5F0)',
    border: '1px solid #BDE5F0',
  },
  unlikeBtn: {
    width: '56px',
    height: '52px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #EF669B -76.92%, rgba(255, 255, 255, 0) 68.27%), linear-gradient(0deg, #F5CFDE, #F5CFDE)',
    border: '1px solid #F5CFDE',
  },
  selectedStar: {
    position: 'absolute',
    top: -10,
    right: -15,
    animation: '$star 0.8s ease-in-out',
  },
  iUnderstandText: {
    color: '#A3A3A3',
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '25.59px',
    letterSpacing: '0em',
  },
  '@keyframes star': {
    from: {
      transform: 'scale(0)',
    },
    to: {
      transform: 'scale(1.5)',
    },
  },
})
